const userApi = {
  UPDATEPWD: 'CSVPA-China/api/user/updatepwd', //修改密码
  GETUSERLISTBYPAGER: 'CSVPA-China/api/user/getListByPager', //员工列表
  SAVEUSER: 'CSVPA-China/api/user/save', //增加员工
  UPDATEUSER: 'CSVPA-China/api/user/update', //编辑员工
  GETTEACHERLISTBYROL: 'CSVPA-China/api/user/getListByRole', //所有老师
  GETLISTCLASSADVISER: 'CSVPA-China/api/user/getListClassAdviser', //所有班主任
  CHANGEHEADER: 'CSVPA-China/api//user/headPortrait', //修改头像
  DELETESTAFF: 'CSVPA-China/api/user/delete',
  // GETLISTCLASSADVISER: 'CSVPA-China/api/user/getListClassAdviser', //查询全部班主任
  COURSEGETLISTALL: 'CSVPA-China/api/course/getListAll', //所有课程查询
  SENDVERIFICATIONCODE: 'CSVPA-China/api/user/sendVerificationCode', //发送验证码
  RESETPASSWORD: 'CSVPA-China/api/user/resetPassword' //重置密码
}

export default userApi
